import React, { useEffect, useState } from 'react';
import { auth } from '../firebase';
import SiteService from './SiteService';

const Home = () => {
    const [user, setUser] = useState(null);
    const [showGuide, setShowGuide] = useState(false);
    const [preparationLevel, setPreparationLevel] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
            if (firebaseUser) {
                setUser(firebaseUser); // displayName vs. için

                try {
                    const response = await SiteService.getPreparationStatus();
                    const level = response.data.preparationLevel;
                    console.log("Preparation level:", level);
                    setPreparationLevel(level);
                    setShowGuide(level < 5);
                } catch (error) {
                    console.error('Preparation status alınamadı:', error);
                }
            }
        });

        return () => unsubscribe(); // temizlik
    }, []);

const renderGuide = () => {
    const steps = [
        { level: 1, text: "Ana sayaç tanımlayın" },
        { level: 2, text: "Süzme sayaçları ekleyin" },
        { level: 3, text: "Elektrik faturanızı girin" },
        { level: 4, text: "Süzme sayaç okuma değerlerini girin" },
        { level: 5, text: "Faturayı süzme sayaçlara paylaşın" },
    ];

    // Rehberin ilk 2 adımı gösterilecek mi?
    const showFirstSteps = preparationLevel < 2;

    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            padding: '1.5rem',
            borderRadius: '12px',
            marginTop: '2rem',
            boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
            maxWidth: '600px'
        }}>
            <h2 style={{
                fontSize: '1.4rem',
                fontWeight: 600,
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }}>
                <span role="img" aria-label="wrench">🛠️</span>
                Başlamadan Önce Hazırlıklar
            </h2>

            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem' }}>
                {steps.map((step) => {
                    const isDone = preparationLevel >= step.level;

                    // 1. ve 2. adım gösterilmeyecekse atla
                    if (!showFirstSteps && step.level <= 2) {
                        return null;
                    }

                    // Başlıkları yerleştir
                    const showInitialHeading = step.level === 1 && showFirstSteps;
                    const showSecondaryHeading = step.level === 3 && !showInitialHeading;

                    return (
                        <React.Fragment key={step.level}>
                            {showInitialHeading && (
                                <p style={{
                                    marginTop: '0.5rem',
                                    marginBottom: '1rem',
                                    fontWeight: 'bold',
                                    color: '#495057'
                                }}>
                                    Bir kereye mahsus aşağıdaki tanımları yapın:
                                </p>
                            )}
                            {showSecondaryHeading && (
                                <p style={{
                                    marginTop: '1.5rem',
                                    marginBottom: '1rem',
                                    fontWeight: 'bold',
                                    color: '#495057'
                                }}>
                                    Sistemi kullanmak için her şey hazır:
                                </p>
                            )}
                            <li style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '0.75rem',
                                fontSize: '1rem',
                                color: isDone ? '#6c757d' : '#212529',
                            }}>
                                <div style={{
                                    width: '24px',
                                    height: '24px',
                                    minWidth: '24px',
                                    borderRadius: '50%',
                                    marginRight: '12px',
                                    backgroundColor: isDone ? '#198754' : '#dee2e6',
                                    color: isDone ? 'white' : '#adb5bd',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    boxShadow: isDone ? 'inset 0 0 0 2px white' : 'none'
                                }}>
                                    {isDone ? '✓' : '•'}
                                </div>
                                {step.text}
                            </li>
                        </React.Fragment>
                    );
                })}
            </ul>

            <p style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                Yeni kullanıcı olduğunuz için bu rehberi görüyorsunuz
            </p>
        </div>
    );
};



    return (
        <div>
            {showGuide && renderGuide()}
        </div>
    );
};

export default Home;
